/* eslint-disable */
import { useParams } from "react-router-dom";
import settings from "../../../configs/settings";
import { useEffect, useState, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Grid, Paper, Typography } from "@mui/material";
import Cliente from "./Cliente";
import Receta from "./Receta";
import Anteojo from "./Anteojo";
import Arreglo from "./Arreglo";
import Producto from "./Producto";
import LenteContacto from "./LenteContacto";
import Finalizar from "./Finalizar";
import Cobranza from "./Cobranza";
import EntregaArticulos from "./EntregaArticulos";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { getGestionAtencion } from "../../../project/services/GestionAtencionService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney, generaCodigo } from "../../utils/utils"

//
// ################################################################################
//
const GestionAtencion = () => {
  const params = useParams();
  const idGestionAtencion = params.idGestionAtencion;
  const action = params.action;
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const {
    isDoingSomething,
    setIsDoingSomething,
    tabGestionAtencionValue,
    setTabGestionAtencionValue,
    codigoGA,
    isSetClient,
    cliente,
    setDisabledCliente,
    isRecetaError,
    setGestionAtencion,
    setCodigoGA,
    finalizar,
    showImportesContado,
    showTabCobranzas,
    showTabEntregaArticulos,
    sucursalGA,
    fechaCreacionGA,
  } = useContext(GestionAtencionContext);

  const { subTotalGestionAtencion, subTotalContadoGestionAtencion } = finalizar;
  //
  // ################################################################################
  //
  useEffect(() => {

    const gestionAtencion = async () => {

      setDisabledCliente(true);
      setIsDoingSomething(true);
      const response = await getGestionAtencion(idGestionAtencion);
      setIsDoingSomething(false);
      setDisabledCliente(false);

      if (response.ok) {
        setGestionAtencion(response.data.data, action);
        setTabGestionAtencionValue("cliente");
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    if (action === "new") {
      setCodigoGA(generaCodigo(7));
    } else {
      gestionAtencion();
    }
  }, []);
  //
  // ################################################################################
  //
  const handleChange = (event, newValue) => {
    setTabGestionAtencionValue(newValue);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Box
          sx={{
            p: 1.5,
            backgroundColor: "CornflowerBlue",
            borderRadius: "5px",
          }}
        >
          <Grid container>
            <Grid item xs={12} md={6}>
              <Typography
                component="div"
                align="left"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                }}
              >
                {codigoGA} - {cliente.nombre} {cliente.apellido}
              </Typography>
            </Grid>

            <Grid item xs={12} md={showImportesContado ? 3 : 6}>
              <Typography
                component="div"
                align="right"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                }}
              >
                TOTAL DE LISTA: {formatMoney(subTotalGestionAtencion)}
              </Typography>
            </Grid>

            {showImportesContado && (
              <>
                <Grid item xs={12} md={3}>
                  <Typography
                    component="div"
                    align="right"
                    sx={{
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "1.25rem",
                    }}
                  >
                    TOTAL DE CONTADO: {formatMoney(subTotalContadoGestionAtencion)}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>

          {action !== "new" && (
            <Box sx={{ pt: 1 }}>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Typography
                    component="div"
                    align="left"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.25rem",
                    }}
                  >
                    {sucursalGA}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    component="div"
                    align="right"
                    sx={{
                      // fontWeight: "bold",
                      fontSize: "1.25rem",
                    }}
                  >
                    Fecha/hora de creación: {fechaCreacionGA}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>

        <Box sx={{ m: 2 }}>
          <Tabs
            sx={{ mb: 2 }}
            value={tabGestionAtencionValue}
            onChange={handleChange}
            aria-label="Gestión de Atención"
          >
            <Tab
              label="Cliente"
              value="cliente"
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            <Tab
              label="Receta"
              value="receta"
              disabled={!isSetClient}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            <Tab
              label="Anteojos"
              value="anteojos"
              disabled={!isSetClient || isRecetaError}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            <Tab
              label="Arreglos"
              value="arreglos"
              disabled={!isSetClient || isRecetaError}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            <Tab
              label="Productos"
              value="productos"
              disabled={!isSetClient || isRecetaError}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            <Tab
              label="Lentes de Contacto"
              value="lentesContacto"
              disabled={!isSetClient || isRecetaError}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />

            {action === "view" && (
              <Tab
                label="Cobranzas"
                value="cobranzas"
                disabled={!showTabCobranzas}
                sx={{
                  color: "gray",                // color normal
                  "&.Mui-selected": {
                    color: "SteelBlue",         // color seleccionado
                    fontWeight: "bold",
                  },
                }}
              />
            )}

            {action === "view" && (
              <Tab
                label="Entrega de Artículos"
                value="entregaArticulos"
                disabled={!showTabEntregaArticulos}
                sx={{
                  color: "gray",                // color normal
                  "&.Mui-selected": {
                    color: "SteelBlue",         // color seleccionado
                    fontWeight: "bold",
                  },
                }} />
            )}

            <Tab
              label={action === "view" ? "Totales + Info" : "Finalizar"}
              value="finalizarTotales"
              disabled={!isSetClient || isRecetaError || finalizar.subTotalGestionAtencion === 0}
              sx={{
                color: "gray",                // color normal
                "&.Mui-selected": {
                  color: "SteelBlue",         // color seleccionado
                  fontWeight: "bold",
                },
              }}
            />
          </Tabs>

          {tabGestionAtencionValue === "cliente" && <Cliente />}
          {tabGestionAtencionValue === "receta" && <Receta />}
          {tabGestionAtencionValue === "anteojos" && <Anteojo />}
          {tabGestionAtencionValue === "arreglos" && <Arreglo />}
          {tabGestionAtencionValue === "productos" && <Producto />}
          {tabGestionAtencionValue === "lentesContacto" && <LenteContacto />}
          {tabGestionAtencionValue === "cobranzas" && <Cobranza />}
          {tabGestionAtencionValue === "entregaArticulos" && <EntregaArticulos />}
          {tabGestionAtencionValue === "finalizarTotales" && <Finalizar />}
        </Box>
      </Paper >

      {/* >>>> Messages */}

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default GestionAtencion;
